"use client";

import { useRef } from "react";

import { Container } from "@/src/components/ui/Container";
import Section from "@/src/components/ui/Section";
import { Heading } from "@/src/components/ui/Typography";
import { StickyColumnUntilLevel } from "@/src/components/molecules/StickyColumnUntilLevel";

import { ImpactStatItem } from "./ImpactStatItem";
import type { ImpactStatItemData } from "./ImpactGenerated.types";

interface ImpactGeneratedProps {
  items: ImpactStatItemData[];
}

export function ImpactGenerated({ items }: ImpactGeneratedProps) {
  const boundsRef = useRef<HTMLDivElement>(null);

  if (items.length === 0) return null;

  return (
    <Section className="bg-white">
      <Container>
        <div className="grid gap-6 md:grid-cols-2 md:gap-24">
          <StickyColumnUntilLevel boundsRef={boundsRef} className="h-fit self-start">
            <Heading as="h2" size="displayLG">
              Impact Generated
            </Heading>
          </StickyColumnUntilLevel>

          <div ref={boundsRef} className="grid gap-8 md:gap-13 sm:grid-cols-2">
            {items.map((item, index) => (
              <ImpactStatItem key={index} item={item} />
            ))}
          </div>
        </div>
      </Container>
    </Section>
  );
}
